<span class="flag-icon flag-icon-{{ countryIsoCode | lowercase }}"></span>
